import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Cartesian, { minimumEnquiry } from './cartesian';
import { UNDEF, stubFN, extend2, toPrecision, pluckNumber, setLineHeight, pluck } from '../lib';
import { getTrendLineLimits, _drawLabel, _parseLabel, getLabel, setAxisPadding } from './common-api';
var ROTATED_LABEL_PADDING = 3,
    ROTATED_LABEL_MIN_GAP = 10;

var CartesainLabelManager =
/*#__PURE__*/
function (_Cartesian) {
  _inherits(CartesainLabelManager, _Cartesian);

  function CartesainLabelManager() {
    _classCallCheck(this, CartesainLabelManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(CartesainLabelManager).apply(this, arguments));
  }

  _createClass(CartesainLabelManager, [{
    key: "_getHMaxLabelDimention",
    value: function _getHMaxLabelDimention(a) {
      function b(a, b) {
        switch (b.toLowerCase()) {
          case 'left':
            return R(T._getCustomPixel(a));

          case 'right':
            return R(W.width - T._getCustomPixel(a));
        }
      }

      var c,
          d,
          e,
          f,
          g,
          h,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          z,
          A,
          B,
          C,
          D,
          E,
          F,
          G,
          H,
          I,
          J,
          K,
          L,
          M,
          N = Math.ceil,
          O = Math.max,
          P = Math.floor,
          Q = Math.min,
          R = Math.abs,
          S = Number.POSITIVE_INFINITY,
          T = this,
          U = T.config,
          V = T.getFromEnv('chart'),
          W = V.config,
          X = V.getFromEnv('smartLabel'),
          Y = U.axisRange,
          Z = U.labels,
          $ = U.labelDisplay,
          _ = U.slantLabel,
          aa = Z.style,
          ba = U.maxLabelHeight,
          ca = T.getInterval(),
          da = U.staggerLines,
          ea = U.labelStep,
          fa = W.canvasLeft,
          ga = W.canvasRight,
          ha = da - 2,
          ia = Y.max,
          ja = Y.min,
          ka = 0,
          la = U.tickValues && U.tickValues.tickValue,
          ma = la && la.length,
          na = V.distributedColumns,
          oa = 0,
          pa = {
        text: UNDEF,
        width: 0,
        style: UNDEF
      },
          qa = 0,
          ra = 4,
          sa = stubFN,
          ta = stubFN,
          ua = stubFN,
          va = {},
          wa = 0,
          xa = !1,
          ya = 0,
          za = !1,
          Aa = S,
          Ba = U.ticks,
          Ca = S;
      if (na) for (t = 0; t < ma; t++) {
        la[t + 1] ? la[t].x && (la[t].plotWidth = T.getPixel(la[t + 1].x - la[t].x) - T.getPixel(0)) : la[t].plotWidth = T.getPixel(W.canvasRight - la[t].x) - T.getPixel(0);
      }
      if (U.tickValues && (!la || 0 === la.length)) return {
        width: 0,
        height: 0
      };

      if ('rotate' === $ && (U.rotateLabels = 1), U.tickValues || (U.irregularCatAxis = !1), U.sWidthAdjstFactor = d = 0 == ha ? 1 : 1 == ha ? 1.5 : ha, X.useEllipsesOnOverflow(W.useEllipsesWhenOverflow), X.setStyle({
        fontSize: aa.fontSize,
        fontFamily: aa.fontFamily,
        lineHeight: aa.lineHeight,
        fontWeight: aa.fontWeight
      }), U.irregularCatAxis) {
        for (la.sort(function (a, b) {
          return a.x - b.x;
        }), t = 0, oa = la.length; t < oa; t++) {
          if (g = la[t], 'undefined' != typeof z) {
            if (Ca = R(g.x - z), D = R(T._getCustomPixel(ja) - T._getCustomPixel(ja + Ca)), X.setStyle(Object.assign({}, g.style)), B = X.getOriSize('W'), C = B.width, D < 1.2 * C) {
              g.label = '', Ca = Aa;
              continue;
            }

            E._individualIWR = D, g._individualIWL = D, Aa = Ca;
          }

          E = g, z = g.x;
        }

        for (Ca === S && (Ca = P(Q(g.x, ia - g.x)), Ca = O(Ca, 4)), t = 0, oa = la.length; t < oa; t++) {
          g = la[t], t || (g._individualIWL = 1 / 0), t === oa - 1 && (g._individualIWR = 1 / 0), g.individualIW = Q(g._individualIWL, g._individualIWR);
        }

        j = R(T._getCustomPixel(ja) - T._getCustomPixel(ja + Ca)), j = Q(2 * b(la[0].x, 'left'), 2 * b(la[oa - 1].x, 'right'), j);
      } else j = R(T._getCustomPixel(ja) - T._getCustomPixel(ja + ca));

      if (a = ba || a, va.__root__ = {
        getHeight: function getHeight(a) {
          var b = la[a],
              c = b._ovrStyle.lineHeight,
              d = parseInt(c.replace(/(\d+)px/, '$1'), 10);
          return d;
        },
        getWidth: function getWidth() {
          return a;
        },
        getCalculatedLabelStep: function getCalculatedLabelStep(a) {
          var b,
              c,
              d,
              e,
              f,
              g,
              i,
              l,
              m,
              n,
              o = 0,
              p = a.length,
              q = Number.NEGATIVE_INFINITY,
              r = {},
              s = 0;

          for (o = 0; o < p; o++) {
            e = a[o], e.style = e.style || {};
          }

          if (U.irregularCatAxis) return U.labelStep;

          for (o = 0; o < p; o++) {
            (e = a[o], !!e) && (e.label || (e.label = ''), f = e.oriLabel || e.label, h = {
              fontSize: aa.fontSize,
              fontFamily: aa.fontFamily,
              lineHeight: aa.lineHeight,
              fontWeight: aa.fontWeight
            }, s++, e.style = e.style || {}, extend2(h, e.style), b = h.fontSize + h.fontFamily + h.lineHeight + h.fontWeight, r[b] ? f.length > r[b].label.length && (r[b].label = f) : r[b] = {
              label: f,
              style: h
            });
          }

          for (g in r) {
            r.hasOwnProperty(g) && (c = r[g].style, d = r[g].label, c.lineHeight = setLineHeight(c), X.setStyle(c), U.rotateLabels && (m = parseInt(c.lineHeight.replace(/(\d+)px/, '$1'), 10)), k = X.getSmartText(d, UNDEF, m), l = 0 === U.rotateLabels ? 60 < k.width ? 60 : k.width : k.height, q = O(l, q));
          }

          return i = P(R(T._getCustomPixel(ia) - T._getCustomPixel(ja)) / q), n = O(N(s / i), U.labelStep), j = R(T._getCustomPixel(ja) - T._getCustomPixel(ja + n)), s <= i ? U.labelStep : n;
        }
      }, va._inProp = {}, va.getCopyById = function (a) {
        var b,
            c = this,
            d = c._inProp,
            e = c.__root__,
            f = d.copyStore;
        return (f = f || {}, b = f[a], b) ? b : (extend2(b = f[a] = {}, e), b);
      }, U.tickValues) {
        for ('rotate' === $ ? (Z.rotation = _ ? 300 : 270, n = va.getCopyById('rotate')) : 'stagger' === $ ? (n = va.getCopyById('stagger'), n.getHeight = function (a) {
          var b, c, d, e;
          return b = U.tickValues.tickValue, c = b[a], d = c && c.style || (c.style = {}), h = {
            fontSize: aa.fontSize,
            fontFamily: aa.fontFamily,
            lineHeight: aa.lineHeight,
            fontWeight: aa.fontWeight
          }, extend2(h, d), X.setStyle(h), e = X.getOriSize(c.label), e.height;
        }, n.getWidth = function (a) {
          return ra = 1, a.individualIW ? a.individualIW : 2 * j * d - ra;
        }, ua = function ua(b) {
          var c,
              d,
              e,
              f,
              g,
              h,
              i,
              j,
              k = b.length,
              l = 0;
          if (X.setStyle(aa), j = X.getOriSize('WWW'), e = j.height, d = b[k - 1], P(d._cumulativeSum) <= N(k * (e + 2))) h = P(a / e), da = 0 > h - da ? h : da;else {
            h = P(a / (e + 4));

            do {
              for (l = 0, i = h, (f = i - 1, k = b.length); f < k;) {
                if (k - f < h && (f = k - 1), c = b[f], g = c._cumulativeSum - l, ~~g > -~a) {
                  xa = !0;
                  break;
                } else xa = !1;

                l = c._cumulativeSum, f += i;
              }
            } while (h-- && xa);

            h++, da = Q(da, h);
          }
          U.drawnStaggerLines = da;
        }, sa = function sa(a) {
          var b,
              c,
              d,
              f,
              g,
              h = 0;

          for (g = 0, d = a.length; g < d; g++) {
            (b = a[g], !b.stepSkipped) && (c = b && b.style || {}, (f = c.lineHeight) || (f = aa.lineHeight), e = h++ % da, b.labelPadding = e ? f.replace(/px/i, '') * e : 0);
          }
        }) : 'none' === $ ? (n = va.getCopyById('none'), n.getHeight = stubFN, n.getWidth = stubFN, ta = stubFN, U.rotateLabels && (Z.rotation = _ ? 300 : 270, A = a), n.getCalculatedLabelStep = function () {
          return U.labelStep;
        }) : (n = va.getCopyById('auto'), n.getHeight = function () {
          return a;
        }, n.getWidth = function (a) {
          return a.individualIW ? a.individualIW : j - 2 * ra;
        }, ta = function ta(a, b) {
          var c,
              d,
              e,
              f,
              g,
              h,
              p = V.getFromEnv('chart-attrib'),
              q = pluckNumber(p && p.rotatelabels);

          if (!U.irregularCatAxis && (X.setStyle(a), d = X.getOriSize('WWW'), c = d.width, c >= j && 0 !== q)) {
            for (Z.rotation = _ ? 300 : 270, Z.forceRotate = !0, n = va.getCopyById('rotate'), l = n.getWidth, m = n.getHeight, pa.width = 0, (e = 0, f = b.length); e < f; e++) {
              (g = b[e], g && (g.label || g.oriLabel) && 0 !== pluckNumber(g.showlabel, U.showLabels, 1) && !0 !== g.stepSkipped) && (h = g._ovrStyle, X.setStyle({
                fontSize: h.fontSize,
                fontFamily: h.fontFamily,
                lineHeight: h.lineHeight,
                fontWeight: h.fontWeight
              }), k = X.getSmartText(g.oriLabel, l(g), m(e)), g.label = k.text, g.labelTooltext = k.tooltext, g._sLabel = k, pa.width < k.width && (pa.text = k.text, pa.width = k.width, pa.height = k.height, pa.style = h));
            }

            o = pa.text;
          }
        }), l = n.getWidth, m = n.getHeight, ea = U.labels.step = U.labelStep = U._oriLabelStep, ea = U.labels.step = U.labelStep = n.getCalculatedLabelStep(la), q = minimumEnquiry(la), t = q, p = 0, u = 0, oa = la.length; t < oa; t++, p++) {
          if (g = la[t], g && (g.label || g.oriLabel) && 0 !== pluckNumber(g.showlabel, U.showLabels, 1)) {
            if (za = !0, h = {
              fontSize: aa.fontSize,
              fontFamily: aa.fontFamily,
              lineHeight: aa.lineHeight,
              fontWeight: aa.fontWeight
            }, extend2(h, g.style), h.lineHeight = setLineHeight(h), K = h.fontSize + h.fontFamily + h.lineHeight + h.fontWeight, K != J && (X.setStyle(h), J = K), p % ea) {
              g.stepSkipped = !0, g.appliedSmartLabel = !1, ya++;
              continue;
            } else g.appliedSmartLabel = !0, g.stepSkipped = !1;

            g._ovrStyle = h, la[t].plotWidth ? c = O('rotate' === $ ? la[t].plotWidth - 6 : 0, m(t)) : ('rotate' === $ ? t < oa - 1 && (f = T.getPixel(t + 1) - T.getPixel(t) - ROTATED_LABEL_MIN_GAP) : f = 0, 'rotate' === $ && isNaN(+f) && (f = W.canvasWidth / T.getVisibleLength() - ROTATED_LABEL_PADDING), c = O(f, m(t))), k = X.getSmartText(g.oriLabel || g.label, l(g), c), wa += k.height + 2, T.components.labels[u++] = {
              config: {
                width: k.width,
                height: k.height,
                props: {
                  label: {}
                }
              }
            }, g._cumulativeSum = wa, g.oriLabel = g.oriLabel || g.label, g.label = k.text, g.labelTooltext = k.tooltext, g._sLabel = k, pa.width < k.oriTextWidth && (extend2(pa, k), pa.style = h), qa < k.height && (qa = k.height);
          }
        }

        if (!za) return {
          height: 0,
          width: 0
        };
        if (ua(la, ya), sa(la, ya), ta(pa.style, la), o = pa.text || '', 'mixed' === U.xAxisLabelMode) for (x = U.isPercent ? V.getFromEnv('number-formatter').percentValue : V.getFromEnv('number-formatter').xAxis, ka = o.length, (t = 0, L = Ba && Ba.length); t < L; ++t) {
          w = Ba[t], v = '' + x.call(V.getFromEnv('number-formatter'), w, U.axisIndex), v.length > ka && (o = v, ka = v.length);
        }

        for (pa.height = O(qa, pa.height || 0), H = la.length, (t = 0, oa = la.length); t < oa && (F = la[t], !F._sLabel); t++) {
          ;
        }

        for (oa = la.length, t = oa - 1; 0 <= t && (G = la[t], !G._sLabel); t--) {
          ;
        }

        I = 1 !== T.getZoom(), Z.rotation || I || !F._sLabel ? (U.axisEndLabelDisplaySpace.left = 0, U.axisEndLabelDisplaySpace.right = 0) : (U.axisEndLabelDisplaySpace.left = O(fa - (T._getCustomPixel(F.x || 0) - F._sLabel.width / 2), 0), U.axisEndLabelDisplaySpace.right = O(T._getCustomPixel(G.x || H - 1) + G._sLabel.width / 2 - ga, 0)), y = pa;
      } else {
        for (x = U.numberFormatterFn ? V.getFromEnv('number-formatter')[U.numberFormatterFn] : U.isPercent ? V.getFromEnv('number-formatter').percentValue : V.getFromEnv('number-formatter').xAxis, t = 0, L = Ba && Ba.length; t < L; ++t) {
          M = Ba[t], w = toPrecision(M, 10), v = '' + x.call(V.getFromEnv('number-formatter'), w, U.axisIndex), M === ja && (r = v), M === ia && (s = v), y = X.getOriSize(v), T.components.labels[t] = {
            config: {
              width: y.width,
              height: y.height,
              props: {
                label: {}
              }
            }
          }, v.length > ka && (o = v, ka = v.length);
        }

        X.setStyle({
          fontSize: aa.fontSize,
          fontFamily: aa.fontFamily,
          lineHeight: aa.lineHeight,
          fontWeight: aa.fontWeight
        }), y = X.getOriSize(o || ''), 'rotate' === $ && (Z.rotation = 270), U.rotateLabels && (_ ? Z.rotation = 300 : Z.rotation = 270), Z.rotation || (r = X.getOriSize(r || ''), s = X.getOriSize(s || ''), U.axisEndLabelDisplaySpace.left = r.width / 2 + 2, U.axisEndLabelDisplaySpace.right = s.width / 2 + 2);
      }

      return U.tickValues && 'stagger' === $ && (y.height = da * pa.height), y.width = A ? Q(A, y.width) : y.width, y.width = pluckNumber(y.width), y.maxWidth = pluckNumber(y.maxWidth), y;
    }
  }, {
    key: "_getVMaxLabelDimention",
    value: function _getVMaxLabelDimention(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q = this,
          r = q.config,
          s = q.getFromEnv('chart'),
          t = s.config,
          u = s.getFromEnv('smartLabel'),
          v = r.labels.style,
          w = r.useEllipsesWhenOverflow,
          x = r.maxLabelWidthPercent,
          y = r.minLabelWidthPercent,
          z = 0,
          A = s.getFromEnv('dataSource').categories,
          B = {
        height: 0,
        width: 0
      },
          C = r.ticks,
          D = {};

      if (u.useEllipsesOnOverflow(t.useEllipsesWhenOverflow), u.setStyle({
        fontSize: v.fontSize,
        fontFamily: v.fontFamily,
        lineHeight: v.lineHeight,
        fontWeight: v.fontWeight
      }), r.tickValues) {
        for (A && (D = {
          fontFamily: A[0].font,
          fontSize: A[0].fontsize,
          color: A[0].fontcolor
        }), x && (c = x / 100 * t.width, c < a && (a = c)), y && (d = y / 100 * t.width, d > a && (a = d)), j = r.tickValues.tickValue, (e = 0, k = j.length); e < k; e++) {
          (l = j[e], 0 !== pluckNumber(l.showlabel, r.showLabels)) && (o = {
            fontFamily: pluck(l.font, l.labelfont, D.fontFamily, v.fontFamily),
            fontSize: pluck(l.fontsize, l.labelfontsize, D.fontSize, v.fontSize).replace(/px/i, '') + 'px',
            fontWeight: 'normal' == v.fontWeight ? pluckNumber(l.fontbold, l.labelfontbold, 0) ? 'bold' : 'normal' : v.fontWeight,
            fontStyle: 'normal' == v.fontStyle ? pluckNumber(l.fontitalic, l.labelfontitalic, 0) ? 'italic' : 'normal' : v.fontStyle
          }, p = {
            fontFamily: pluck(o.fontFamily, D.fontFamily, v.fontFamily),
            fontSize: pluck(o.fontSize, D.fontSize, v.fontSize),
            fontWeight: pluck(o.fontWeight, v.fontWeight),
            fontStyle: pluck(o.fontStyle, v.fontStyle)
          }, p.lineHeight = setLineHeight(p), u.setStyle(p), m = u.getSmartText(l.oriLabel || l.label, a, v.lineHeight, w), q.components.labels[e] = {
            config: {
              width: m.width,
              height: m.height,
              props: {
                label: {}
              }
            }
          }, l.oriLabel = l.oriLabel || l.label, l.label = h = m.text, l.labelTooltext = m.tooltext, m.width > z && (B = m, z = m.width));
        }

        return B;
      }

      for (n = r.numberFormatterFn ? s.getFromEnv('number-formatter')[r.numberFormatterFn] : r.isPercent ? s.getFromEnv('number-formatter').yAxisPercentValue : s.getFromEnv('number-formatter').yAxis, e = 0, f = C && C.length; e < f; ++e) {
        g = toPrecision(C[e], 10), h = '' + n.call(s.getFromEnv('number-formatter'), g, r.axisIndex), m = u.getSmartText(h), q.components.labels[e] = {
          config: {
            width: m.width,
            height: m.height,
            props: {
              label: {}
            }
          }
        }, h.length > z && (b = h, z = h.length);
      }

      return u.getOriSize(b);
    }
  }, {
    key: "getCleanValue",
    value: function getCleanValue(a, b) {
      var c = this,
          d = c.getFromEnv('number-formatter');
      return d.getCleanValue(a, b);
    }
  }, {
    key: "generateMinorTicks",
    value: function generateMinorTicks() {
      if (this) return [];
    }
  }, {
    key: "setCanvas",
    value: function setCanvas(a) {
      var b = this,
          c = b.config;
      c.canvas = a;
    }
  }, {
    key: "_adjustNumberFormatter",
    value: function _adjustNumberFormatter(a) {
      var b,
          c,
          d = this,
          e = d.config,
          f = e.axisIndex,
          g = e.isVertical,
          h = d.getFromEnv('chart'),
          i = h.getFromEnv('number-formatter'),
          j = e._defaultDecimalPrecision,
          k = e._defaultForceDecimal,
          l = 0;
      c = g || 'yAxis' === e.numberFormatterFn ? (i.Y[f] || i.Y[0]).yAxisLabelConf : i.paramX, j === UNDEF ? e._defaultDecimalPrecision = c.decimalprecision : c.decimalprecision = j, k === UNDEF ? e._defaultForceDecimal = c.forcedecimals : c.forcedecimals = k;
      0 < parseInt(a, 10) || (b = a.toString().split('.')[1], b && (l = b.match(/^[0]*/)[0].length + 1, l > c.decimalprecision && (c.forcedecimals = 1), c.decimalprecision = Math.max(l, c.decimalprecision)));
    }
  }, {
    key: "setLabelConfig",
    value: function setLabelConfig(a) {
      var b,
          c = this,
          d = c.config,
          e = d.labels;

      for (b in a) {
        a.hasOwnProperty(b) && (e[b] = a[b]);
      }
    }
  }]);

  return CartesainLabelManager;
}(Cartesian);

CartesainLabelManager.prototype._parseLabel = _parseLabel, CartesainLabelManager.prototype._drawLabel = _drawLabel, CartesainLabelManager.prototype.getTrendLineLimits = getTrendLineLimits, CartesainLabelManager.prototype.setAxisPadding = setAxisPadding, CartesainLabelManager.prototype.getLabel = getLabel;
export default CartesainLabelManager;